const getDuplicateItems = arr => arr.filter((x, i) => arr.indexOf(x) !== i);

const getUniqueItems = arr => arr.filter((x, i) => arr.indexOf(x) === i);

const hasDuplicate = arr => getDuplicateItems(arr).length > 0;

const countBy = arr => arr.reduce((acc, x) => {
    acc[x] ? acc[x]++ : acc[x] = 1;
    return acc;
}, {});

const sort = (arr, propName, mode = 'asc') => {
    if (propName) {
        return mode === 'asc'
            ? arr.sort((a, b) => a[propName] > b[propName] ? 1 : a[propName] < b[propName] ? -1 : 0)
            : arr.sort((a, b) => a[propName] < b[propName] ? 1 : a[propName] > b[propName] ? -1 : 0);
    }

    return mode === 'asc'
        ? arr.sort((a, b) => a > b ? 1 : a < b ? -1 : 0)
        : arr.sort((a, b) => a < b ? 1 : a > b ? -1 : 0);
};

const getMaxOfArray = arr => Math.max.apply(null, arr); // OR Math.max(...arr)

const getMinOfArray = arr => Math.min.apply(null, arr); // OR Math.min(...arr)

const getMaxOfBigArray = arr => {
    let max = arr[0];
    for (let i = 1; i < arr.length; ++i) {
        if (arr[i] > max) max = arr[i];
    }

    return max;
};

const getMinOfBigArray = arr => {
    let min = arr[0];
    for (let i = 1; i < arr.length; ++i) {
        if (arr[i] < min) min = arr[i];
    }

    return min;
};

const remove = (arr, itemToBeRemoved) => arr.filter(x => x !== itemToBeRemoved);

const findIndex = (arr, propName, valueToFind) => arr.map(x => x[propName]).indexOf(valueToFind);

const groupBy = (arr, key) => arr.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
}, {});

const shuffle = arr => {
    for (var i = arr.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1)),
            tmp = arr[i];

        arr[i] = arr[j];
        arr[j] = tmp;
    }

    return arr;
}

export default {
    getDuplicateItems,
    getUniqueItems,
    hasDuplicate,
    countBy,
    groupBy,
    sort,
    getMaxOfArray,
    getMinOfArray,
    getMaxOfBigArray,
    getMinOfBigArray,
    remove,
    findIndex,
    shuffle
}